/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateTankTypeResponse model module.
* @module model/CreateTankTypeResponse
* @version 2020-12-7
*/
export default class CreateTankTypeResponse {
    /**
    * Constructs a new <code>CreateTankTypeResponse</code>.
    * タンクタイプ登録レスポンス
    * @alias module:model/CreateTankTypeResponse
    * @class
    * @param id {Number} 
    * @param result {module:model/CreateTankTypeResponse.ResultEnum} 
    */

    constructor(id, result) {
        
        
        this['id'] = id;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>CreateTankTypeResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateTankTypeResponse} obj Optional instance to populate.
    * @return {module:model/CreateTankTypeResponse} The populated <code>CreateTankTypeResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateTankTypeResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * @member {module:model/CreateTankTypeResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
